<div class="saved-search-container" *ngIf="showViewFilterSection">
  
  <!-- Add New / Cancel Action -->
  <div *ngIf="showActionViewSearchButton" class="action-buttons">
    <button class="btn-action btn-toggle" 
            [class.active]="showAddViewFilterButton"
            (click)="showAddViewFilterButton ? hideAddViewFilter() : addViewFilter()"
            [title]="showAddViewFilterButton ? 'Cancel' : 'Register New View'">
      <i class="bi" [class.bi-plus-lg]="!showAddViewFilterButton" [class.bi-x-lg]="showAddViewFilterButton"></i>
    </button>
  </div>

  <div class="divider" *ngIf="showActionViewSearchButton && (showAddViewFilterButton || saveViewArray.length > 0)"></div>

  <!-- Input Area -->
  <div class="input-group-wrapper">
    
    <!-- Text Input for New Save View -->
    <input type="text" 
           *ngIf="!showViewFilterSelectInput" 
           [(ngModel)]="viewFilterInput" 
           [class.text-danger]="isDuplicateName"
           [title]="isDuplicateName ? 'Name already exists' : ''"
           placeholder="Saved View Name" 
           maxlength="20"
           (keyup.enter)="saveViewFilter()">

    <!-- Select Dropdown for Existing Views -->
    <div class="position-relative" *ngIf="showViewFilterSelectInput && saveViewArray.length > 0">
      <ng-select [items]="saveViewArray"
                 bindLabel="name"
                 bindValue="_id"
                 placeholder="Search or Select View"
                 [(ngModel)]="selectedView" 
                 (ngModelChange)="selectViewFilterEvent()" 
                 class="modern-select" 
                 [searchable]="true"
                 [clearable]="false">
        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex align-items-center justify-content-between">
            <span class="fw-semibold">{{ item.name }}</span>
            <i class="bi bi-check-circle-fill text-success" *ngIf="item.status"></i>
          </div>
        </ng-template>
      </ng-select>
      <div class="modified-badge" 
           *ngIf="isModified && selectedView" 
           [class.saving]="isSaving"
           [title]="isSaving ? 'Directly saving your changes...' : 'Unsaved changes detected'"></div>
    </div>

    <!-- Save Confirmation Button -->
    <button class="btn-action btn-save ms-1" 
            (click)="saveViewFilter()"
            *ngIf="showAddViewFilterButton"
            [disabled]="!viewFilterInput.trim() || isSaving || isDuplicateName">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      {{ isSaving ? 'Saving...' : 'Save View' }}
    </button>
  </div>

  <!-- Delete Single View Button -->
  <button class="btn-action btn-delete" 
          *ngIf="showViewFilterRemoveButton"
          (click)="confirmDialog()"
          title="Remove saved view">
    <i class="bi bi-trash"></i>
  </button>

  <div class="divider" *ngIf="showClearFilter"></div>

  <!-- Clear Button -->
  <button class="btn-action btn-clear" 
          *ngIf="showClearFilter" 
          (click)="onClearFilters.emit(); clearFilter()"
          title="Reset grid filters">
    <i class="bi bi-x-circle me-1"></i> Clear
  </button>

</div>
